<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">ANNIVERSARY</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>HAPPY ANNIVERSARY</p>
                        <p>TO THE LOVE OF</p>
                        <p>MY LIFE &</p>
						<p>MY BEST FRIEND</p>
						<p>JOHN HANLEY</p>
						<p>I LOVE YOU</p>
						<p>THANK YOU FOR</p>
						<p>A WONDERFUL</p>
						<p>40 YEARS!</p>
						<p>-BECKY ANN HANLEY</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>HAPPY ANNIVERSARY</p>
                        <p>TO MY LOVE, JOHN HANLEY.</p>
                        <p>THANK YOU FOR 40 YEARS...</p>
						<p>CHEERS TO 40 MORE!</p>
						<p>-BECKY ANN HANLEY:</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">STUDY NOOK</h3>
                        <p>HAPPY ANNIVERSARY</p>
                        <p>TO MY LOVE, JOHN HANLEY,</p>
                        <p>MY COLLEGE SWEETHEART</p>
						<p>WHO I MET FRESHMAN YEAR.</p>
						<p>THANK YOU FOR 40 YEARS...</p>
						<p>CHEERS TO 40 MORE!</p>
						<p>-BECKY ANN HANLEY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">GRADUATION</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>CONGRATULATIONS</p>
						<p>TO OUR FAVORITE</p>
						<p>CAL STATE</p>
						<p>FULLERTON</p>
						<p>GRADUATE:</p>
						<p>JULIA BAXTER</p>
						<p>YOU HAVE MADE</p>
						<p>US ALL SO PROUD!</p>
						<p>LOVE, MOM & DAD,</p>
						<p>PAPA & MAE-MAE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>CONGRATULATIONS</p>
						<p>TO OUR FAVORITE</p>
						<p>TITAN GRADUATE</p>
						<p>JULIE BAXTER '21</p>
						<p>LOVE MOM, DAD & JUSTIN</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>CONGRATULATIONS</p>
						<p>TO OUR FAVORITE</p>
						<p>CALL STATE FULLERTON</p>
						<p>TITAN GRADUATE</p>
						<p>JULIE MARIE BAXTER</p>
						<p>CLASS OF 2021</p>
						<p>LOVE MOM, DAD & JUSTIN</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">STUDENT ATHLETES</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>FROM THE</p>
						<p>CLASSROOM</p>
						<p>TO THE FIELD,</p>
						<p>YOU HAVE ALWAYS</p>
						<p>COMMITTED</p>
						<p>YOURSELF TO</p>
						<p>EXCELLENCE!</p>
						<p>JASON BAXTER</p>
						<p>OUR FAVORITE</p>
						<p>TITAN ATHLETE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>WE ARE SO PROUD OF YOUR</p>
						<p>ACCOMPLISHMENTS</p>
						<p>ON AND OFF THE FIELD</p>
						<p>WE ARE SO PROUD OF YOU!</p>
						<p>JUAN MORALES S $4</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>WE ARE SO PROUD OF YOUR</p>
						<p>ACCOMPLISHMENTS</p>
						<p>ON AND OFF THE FIELD</p>
						<p>JUAN MORALES S #4</p>
						<p>WE ARE YOUR BIGGEST FANS!</p>
						<p>TODAY AND ALWAYS</p>
						<p>MAM, PAPA, PAOLA & CARLO</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">FAMILY</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>CAL STATE</p>
						<p>FULLERTON</p>
						<p>IS OUR</p>
						<p>FAMILY TRADITION</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>THE PARKERS</p>
						<p>A PROUD</p>
						<p>TITAN FAMILY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>TITANS FOREVER!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>CAL STATE FULLERTON</p>
						<p>IS OUR FAMILY TRADITION</p>
						<p>ONCE A TITAN,</p>
						<p>ALWAYS A TITAN!</p>
						<p>THE LEE FAMILY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>CAL STATE FULLERTON</p>
						<p>IS OUR FAMILY TRADITION</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>ONCE A TITAN,</p>
						<p>ALWAYS A TITAN!</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>THE LEE FAMILY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">FATHER'S DAY</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>TO THE BEST DAD</p>
						<p>AND #1 TITANS FAN,</p>
						<p>MARIO GONZALEZ</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>HAPPY FATHER'S DAY!</p>
						<p>ALL OUR LOVE,</p>
						<p>ELIZABETH, JILL,</p>
						<p>MELISSA, RICK,</p>
						<p>& JOSEPH</p>
						<p>2020</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>TO THE BEST DAD</p>
						<p>AND #1 TITANS FAN,</p>
						<p>ASH PATEL</p>
						<p>ALL OUR LOVE</p>
						<p>SAMAIRA, REEVA AND JAI</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>TO THE BEST DAD</p>
						<p>AND #1 TITANS FAN,</p>
						<p>ASH PATEL '88</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>ALL OUR LOVE</p>
						<p>AND APPRECIATION,</p>
						<p>SAMAIRA, REEVA AND JAI</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">MOTHER'S DAY</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>A MOTHER'S</p>
						<p>LOVE IS LIKE</p>
						<p>NO OTHER.</p>
						<p>HAPPY MOTHER'S</p>
						<p>DAY TO THE BEST</p>
						<p>MOM I COULD</p>
						<p>EVER HOPE FOR!</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>LOVE,</p>
						<p>LAUREN</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>A MOTHER'S LOVE</p>
						<p>IS LIKE NO OTHER.</p>
						<p>HAPPY MOTHER'S DAY</p>
						<p>HOPE ALEXANDER</p>
						<p>LOVE, YOUR 3 TITAN KIDS</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>A MOTHER'S LOVE</p>
						<p>IS LIKE NO OTHER.</p>
						<p>HAPPY MOTHER'S DAY</p>
						<p>HOPE ALEXANDER</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>HUGS AND KISSES,</p>
						<p>YOUR THREE TITAN GRADS</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">GENERAL</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>CAL STATE</p>
						<p>FULLERTON IS OUR</p>
						<p>HOME AWAY</p>
						<p>FROM HOME!</p>
						<p>JUDY PRICE &</p>
						<p>JILLIAN WAGNER</p>
						<p>FRIENDS FOR LIFE,</p>
						<p>TITANS FOREVER!</p>
						<p>"FIGHT ON TITANS,</p>
						<p>ALL IN THE GAME"</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>CAL STATE FULLERTON</p>
						<p>IS OUR HOME</p>
						<p>AWAY FROM HOME</p>
						<p>TITANS FOREVER!</p>
						<p>SARA '79 & CHRIS '81</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>CAL STATE FULLERTON</p>
						<p>IS OUR HOME</p>
						<p>AWAY FROM HOME</p>
						<p>TITANS FOREVER!</p>
						<p>SARAH, LORI, HEATHER & JILL</p>
						<p>CLASS OF 2002</p>
						<p>COLLEGE OF THE ARTS</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">INSPIRING</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>THANKFUL</p>
						<p>FOR ALL THE</p>
						<p>WONDERFUL</p>
						<p>MEMORIES</p>
						<p>MADE AT</p>
						<p>CAL STATE</p>
						<p>FULLERTON</p>
						<p>JERRY & MARIA</p>
						<p>PERRISON</p>
						<p>FOREVER TITAN!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>A WARM WELCOME</p>
						<p>TO ALL TITANS</p>
						<p>YOUNG AND OLD.</p>
						<p>TUSKS UP!</p>
						<p>THE WALSH FAMILY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>A WARM WELCOME</p>
						<p>TO ALL TITANS</p>
						<p>YOUNG AND OLD.</p>
						<p>LET YOUR THIRST FOR</p>
						<p>LEARNING LEAD THE WAY.</p>
						<p>WITH TITAN PRIDE,</p>
						<p>THE WALSH FAMILY</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">REMEMBRANCE</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>ALL I AM,</p>
						<p>I OWE TO YOU.</p>
						<p>THANK YOU FOR</p>
						<p>BEING MY</p>
						<p>INSPIRATION.</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>TREVOR DUNE</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>LOST BUT NEVER</p>
						<p>FORGOTTEN!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>ALL I AM,</p>
						<p>I OWE TO YOU.</p>
						<p>THANK YOU FOR</p>
						<p>BEING MY INSPIRATION.</p>
						<p>DR. TERRI SNYDER</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>ALL I AM,</p>
						<p>I OWE TO YOU.</p>
						<p>THANK YOU FOR</p>
						<p>BEING MY TEACHER,</p>
						<p>MY INSPIRATION</p>
						<p>AND FAITHFUL MENTOR.</p>
						<p>DR. TERRI SNYDER</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">TEAM</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>HIT HARD,</p>
						<p>RUN FAST,</p>
						<p>TURN LEFT!</p>
						<p>WE LOVE TITAN</p>
						<p>BASEBALL!</p>
						<p>YOU CAN FIND US</p>
						<p>AT EVERY HOME</p>
						<p>GAME SINCE '98</p>
						<p>PAT & JILLIAN</p>
						<p>HUNTINGTON</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>HIT HARD, RUN FAST,</p>
						<p>AND TURN LEFT!</p>
						<p>CHEERING YOU ON SINCE '96</p>
						<p>WE LOVE TITAN BASEBALL!</p>
						<p>JANICE & GLEN OWENS</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>HIT HARD,</p>
						<p>RUN FAST,</p>
						<p>AND TURN LEFT!</p>
						<p>CHEERING YOU ON SINCE '96</p>
						<p>WE LOVE TITAN BASEBALL!</p>
						<p>JANICE & GLEN OWENS</p>
						<p>OMAHA OR BUST!</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
                <hr/>
				<div class="row">
                    <div class="col-sm-12">
						<h2 class="text-danger">HOLIDAY</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
                        <h3 class="text-danger">12" x 12" PAVER</h3>
                        <p>THE BEST GIFT</p>
						<p>OF ALL WAS</p>
						<p>PASSING ONTO</p>
						<p>ME YOUR LOVE</p>
						<p>OF THE CAL STATE</p>
						<p>FULLERTON</p>
						<p>TITANS!</p>
						<p>MERRY CHRISTMAS,</p>
						<p>DAD & MOM!</p>
						<p>-CHAD JOHNSON</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
                        <h3 class="text-danger">TREE DEDICATIONS</h3>
                        <p>THE BEST GIFT OF ALL WAS</p>
						<p>PASSING ONTO US</p>
						<p>YOUR LOVE OF CSUF!</p>
						<p>MERRY CHRISTMAS MOM & DAD</p>
						<p>LOVE, IMANI, ISIS & ISIAH</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-4">
						<h3 class="text-danger">STUDY NOOK</h3>
                        <p>THE BEST GIFT OF ALL WAS</p>
						<p>PASSING ONTO US</p>
						<p>YOUR LOVE OF LEARNING!</p>
						<p>MERRY CHRISTMAS</p>
						<p>NANA & PAPA</p>
						<p>WITH LOVE,</p>
						<p>IMANI, ISIS & ISIAH</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
						<p>&nbsp;&nbsp;&nbsp;</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-examples',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3,
        p {
            white-space: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// InscriptionExamples.vue?19c60610